import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('Choose a Category');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, '_blank');
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full md:w-72 px-5 py-3 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 hover:border-primary-300 transition-all duration-200 cursor-pointer"
      >
        <span>{selected}</span>
        <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-full md:w-72 bg-background-50 rounded-lg border border-background-200/70 shadow-lg py-2 z-40 max-h-72 overflow-y-auto">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleSelect(cat)}
              className="block w-full text-left px-5 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              {cat.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}